function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M26 15H26.5C30.6421 15 34 18.3579 34 22.5C34 26.6421 30.6421 30 26.5 30H24M18 30H17.5C13.3579 30 10 26.6421 10 22.5C10 18.3579 13.3579 15 17.5 15H20",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M25.6586 11.3414L22.1414 14.8586C22.0633 14.9367 22.0633 15.0633 22.1414 15.1414L25.6586 18.6586C25.7846 18.7846 26 18.6953 26 18.5172V11.4828C26 11.3047 25.7846 11.2154 25.6586 11.3414Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M18.3414 26.3414L21.8586 29.8586C21.9367 29.9367 21.9367 30.0633 21.8586 30.1414L18.3414 33.6586C18.2154 33.7846 18 33.6953 18 33.5172V26.4828C18 26.3047 18.2154 26.2154 18.3414 26.3414Z",
  fill: "currentColor"
});

var SvgLoop = function SvgLoop(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLoop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loop.540cc195.svg";
export { ForwardRef as ReactComponent };